export const wait = (waitTime: number) => {
  return new Promise<void>(resolve => {
    setTimeout(() => {
      resolve();
    }, waitTime);
  });
};
